import { render } from "./QRCodeSection.vue?vue&type=template&id=2799423a&scoped=true"
import script from "./QRCodeSection.vue?vue&type=script&lang=js"
export * from "./QRCodeSection.vue?vue&type=script&lang=js"

import "./QRCodeSection.vue?vue&type=style&index=0&id=2799423a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2799423a"]])

export default __exports__